import React from "react";
import { connect } from "react-redux";
import SideNav from "components/layout-components/SideNav";
import Loading from "components/shared-components/Loading";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import Footer from "components/layout-components/Footer";
import AppViews from "views/app-views";
import { Layout, Grid } from "antd";
import { PageTitleProvider } from "contexts/PageTitleContext";
import TenantSelectionModal from "components/organism/TenantSelectionModal";
import TenantModulosAviso from "components/organism/TenantModulosAviso";

import navigationConfig from "configs/NavigationConfig";
import {
	SIDE_NAV_WIDTH,
	SIDE_NAV_COLLAPSED_WIDTH,
	NAV_TYPE_SIDE,
	NAV_TYPE_TOP,
	DIR_RTL,
	DIR_LTR,
	TEMPLATE,
} from "constants/ThemeConstant";
import utils from "utils";
import { useThemeSwitcher } from "react-css-theme-switcher";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({
	navCollapsed,
	navType,
	location,
	direction,
	layoutZoom,
}) => {
	const currentRouteInfo = utils.getRouteInfo(
		navigationConfig,
		location.pathname,
	);
	const screens = utils.getBreakPoint(useBreakpoint());
	const isMobile = !screens.includes("lg");
	const isNavSide = navType === NAV_TYPE_SIDE;
	const isNavTop = navType === NAV_TYPE_TOP;
	const getLayoutGutter = () => {
		if (isNavTop || isMobile) {
			return 0;
		}
		return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH;
	};

	const { status } = useThemeSwitcher();

	if (status === "loading") {
		return <Loading cover="page" />;
	}

	const getLayoutDirectionGutter = () => {
		const g = getLayoutGutter();
		if (direction === DIR_LTR) {
			return { paddingLeft: g };
		}
		if (direction === DIR_RTL) {
			return { paddingRight: g };
		}
		return { paddingLeft: g };
	};

	// Offset do header fixo só em `.app-content` (_content.less: margin-top: @header-height).
	// Evita somar 70px aqui + 70px no .app-content (faixa vazia grande).
	const contentGutter = {
		...getLayoutDirectionGutter(),
		marginTop: 0,
		minHeight: `calc(100vh - ${TEMPLATE.CONTENT_HEIGHT_OFFSET}px)`,
	};

	return (
		<PageTitleProvider>
			<TenantSelectionModal />
			<Layout className="app-layout-new">
				<HeaderNav isMobile={isMobile} routeInfo={currentRouteInfo} />
				<Layout className="app-container" style={{ marginTop: 0 }}>
					{isNavSide && !isMobile ? (
						<SideNav
							routeInfo={currentRouteInfo}
							hideGroupTitle={navCollapsed}
						/>
					) : null}
					<Layout className="app-layout" style={contentGutter}>
						<div
							className={`app-content ${
								isNavTop ? "layout-top-nav" : ""
							}`}
							style={{
								zoom: layoutZoom / 100,
							}}
						>
							<Content className="app-content-body">
								<TenantModulosAviso />
								<AppViews />
							</Content>
						</div>
						<Footer />
					</Layout>
				</Layout>
				{isMobile && (
					<MobileNav routeInfo={currentRouteInfo} hideGroupTitle={false} />
				)}
			</Layout>
		</PageTitleProvider>
	);
};

const mapStateToProps = ({ theme, gui }) => {
	const { navCollapsed, navType, locale } = theme;
	return {
		navCollapsed,
		navType,
		locale,
		layoutZoom: gui.layoutZoom ?? 100,
	};
};

export default connect(mapStateToProps)(React.memo(AppLayout));
